import { Response } from './providerResponse';
import { mergeDefaultOptions } from './providerOptions';

function trimSlashes(url) {
    return '/' + url.replace(/^\/|\/$/g, '');
}

function getContentType(type) {
    switch (type) {
        case 'form':
            return 'application/x-www-form-urlencoded';
        case 'json':
            return 'application/json';
        default:
            return undefined;
    }
}

function stringify(data) {
    if (data === null) {
        return '';
    }

    switch (typeof data) {
        case 'undefined':
            return '';
        case 'object':
            return JSON.stringify(data);
        default:
            return data.toString();
    }
}

function getDataConverted(type, data = {}) {
    switch (type) {
        case 'form':
            return Object.keys(data).map((field) => {
                return field + '=' + encodeURIComponent(data[field]);
            }).join('&');
        case 'json':
            return stringify(data);
        default:
            return data;
    }
}

function send(method, url, data, options) {
    const { prefix, dataType, headers } = mergeDefaultOptions(options);

    return new Promise((res, rej) => {
        const xhr = new XMLHttpRequest();
        xhr.withCredentials = true;

        xhr.addEventListener("readystatechange", function () {
            if (this.readyState === 4) {
                let responseData;

                switch (true) {
                    case /application\/json/.test(this.getResponseHeader('Content-Type')):
                        responseData = JSON.parse(this.responseText);
                        break;
                    default:
                        responseData = this.responseText;
                }

                const response = new Response(
                    responseData,
                    this.status,
                    this.statusText
                );

                if (this.status >= 400) {
                    rej(response);
                } else {
                    res(response);
                }

            }
        });

        xhr.open(method, prefix + trimSlashes(url));

        const contentType = getContentType(dataType);
        contentType && xhr.setRequestHeader('Content-Type', contentType);
        if (headers) {
            Object.keys(headers).forEach(h => {
                xhr.setRequestHeader(h, headers[h]);
            });
        }
        xhr.send(getDataConverted(dataType, data));
    });

}

export function get(url, data = {}, options) {
    const dataKeys = Object.keys(data);

    if (dataKeys.length) {
        url += '?' + dataKeys.reduce((params, key) => {
            params.push(key + '=' + data[key]);

            return params;
        }, []).join('&');
    }

    return send('get', url, undefined, options);
}

export function post(url, data, options) {
    return send('post', url, data, options);
}


// WEBPACK FOOTER //
// ./src/services/api/utils/xmlHttpRequestProvider.js